import React, { useEffect, useState } from 'react';
import './CharacterLoading.css';

const CharacterLoading = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 10); // 3 seconds for 0 to 100

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="character-loading">
      <div className="loading-text">
        {progress}%
      </div>
      <div >
        <p className='typewriter-text'>.../Ładowanie/Ładowanie...</p>
      </div>
    </div>
  );
};

export default CharacterLoading;
